import { useGlobalContext } from '../context'

function Villager() {
    const {index,players, openWaitingScreen, vote, changeClass} = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Dark Matter)</h4>
            <p className='text-center'>You were sent from above to this small village.It's hard to describe what you are.But one thing is for sure,
            you can't live on your own like thism you are too weak.You have seize someones body before it's too late.</p>
            <p>Pick a side!Each side gives you different perks;</p>
            <p><span className='red'>Vampire side:</span>You become vampire lord </p>
            <p><span className='green'>Villager side:</span>You become a might warrior</p>
            <div className='d-flex'>
                <img  src={`./img/${currentPlayer.class}.png`} alt=""/>
                <div className='btn-holder'>
                    <button disabled={vote ? 'disabled' : ''} onClick={() => { changeClass('warrior', index) }} className='btn btn-success border select' key={index}>Villager</button>
                    <button disabled={vote ? 'disabled' : ''} onClick={() => { changeClass('dracula', index) }} className='btn btn-danger border select'  key={index + 1}>Vampire</button>
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Villager;